import React, { useRef } from "react";
import { Box, Typography } from "@mui/material";
import Draggable from "react-draggable";
import default_theme from "assets/themes/themes";
import PhaseArrow from "components/Common/PhaseArrow";

const StakeholderWhiteboard = ({
  stakeholders,
  domains,
  onPositionChange,
}) => {
  const boardRef = useRef(null);

  return (
    <Box sx={{ mt: 4, mb: 10 }}>
      <Box
        ref={boardRef}
        sx={{
          position: "relative",
          width: "100%",
          height: "500px",
          background: default_theme.palette.primary.main,
          border: `2px solid ${default_theme.palette.other.figmaBlue}`,
          overflow: "visible",
        }}
      >
        {/* CENTER LINES */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: 0,
            width: "100%",
            height: "2px",
            border: `1px solid ${default_theme.palette.other.figmaBlue}`,
            zIndex: 1,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            left: "50%",
            top: 0,
            height: "100%",
            width: "2px",
            border: `1px solid ${default_theme.palette.other.figmaBlue}`,
            zIndex: 1,
          }}
        />

        {/* Arrow INTEREST */}
        <Box
          sx={{
            position: "absolute",
            bottom: -50,
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <Typography sx={{ fontWeight: 800 }}>
            Interest
          </Typography>

          <Box
            sx={{
              position: "relative",
              width: 200, // 👉 control arrow length here
              height: 2,
              backgroundColor: "#23576B",
            }}
          >
            {/* Arrow head */}
            <Box
              sx={{
                position: "absolute",
                right: -6,
                top: "50%",
                transform: "translateY(-50%)",
                width: 0,
                height: 0,
                borderTop: "6px solid transparent",
                borderBottom: "6px solid transparent",
                borderLeft: "8px solid #23576B",
              }}
            />
          </Box>
        </Box>

        {/* Arrow INFLUENCE */}
        <Box
          sx={{
            position: "absolute",
            left: -70,
            top: "50%",
            transform: "translateY(-50%)",
            width: 40,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
          }}
        >

          <Typography
            sx={{
              transform: "rotate(-90deg) translate(-90px, -10px)",
              transformOrigin: "center",
              fontWeight: 800,
              whiteSpace: "nowrap",
            }}
          >
            Influence
          </Typography>


          <Box
            sx={{
              position: "relative",
              height: 200,
              width: 2,
              backgroundColor: "#23576B",
              ml: 5, // 👈 verschuift naar rechts
            }}
          >
            {/* Arrow head */}
            <Box
              sx={{
                position: "absolute",
                top: -6,
                left: "50%",
                transform: "translateX(-50%)",
                width: 0,
                height: 0,
                borderLeft: "6px solid transparent",
                borderRight: "6px solid transparent",
                borderBottom: "8px solid #23576B",
              }}
            />
          </Box>
        </Box>

        {/* QUADRANT LABELS */}
        <Typography sx={{ position: "absolute", top: 8, left: 8, fontWeight: 600, color: default_theme.palette.other.figmaBlue }}>
          Consult
        </Typography>

        <Typography sx={{ position: "absolute", top: 8, right: 8, fontWeight: 600, color: default_theme.palette.other.figmaBlue }}>
          Collaborate
        </Typography>

        <Typography sx={{ position: "absolute", bottom: 8, left: 8, fontWeight: 600, color: default_theme.palette.other.figmaBlue }}>
          Inform
        </Typography>

        <Typography sx={{ position: "absolute", bottom: 8, right: 8, fontWeight: 600, color: default_theme.palette.other.figmaBlue }}>
          Involve
        </Typography>

        {/* STAKEHOLDERS */}
        {stakeholders.map((s, index) => {
          const rect = boardRef.current?.getBoundingClientRect();
          const width = rect?.width || 1;
          const height = rect?.height || 1;

          const x = (s.interest / 100) * width;
          const y = ((100 - s.influence) / 100) * height;

          const domain = domains.find(
            (d) => String(d.id) === String(s.domain_id)
          );

          const bgColor = domain?.color || default_theme.palette.other.figmaBlue;

          return (
            <Draggable
              key={s.id || index}
              bounds="parent"
              position={{ x, y }}
              onStop={(e, data) => {
                const newX = data.x;
                const newY = data.y;

                const interest = Math.round((newX / width) * 100);
                const influence = Math.round(
                  100 - (newY / height) * 100
                );

                onPositionChange(s, { interest, influence });
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  width: 80,
                  height: 80,
                  background: bgColor,
                  color: "#23576B",
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "grab",
                  textAlign: "center",
                  p: 1,
                }}

              >
                {/* GRUE DOT */}
                {!!s.grue && s.grue.trim() !== "" && (
                  <Box
                    sx={{

                      position: "absolute",
                      top: 6,
                      right: 6,
                      width: 10,
                      height: 10,
                      backgroundColor: "red",
                      borderRadius: "50%",
                    }}
                  />
                )}

                <Typography
                  sx={{
                    fontSize: "0.9rem",
                    fontWeight: 600,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 2, // max 2 lines
                    WebkitBoxOrient: "vertical",
                    lineHeight: 1.2,
                  }}
                >
                  {`${s.first_name || ""} ${s.last_name || ""}`.trim() ||
                    "Unnamed stakeholder"}
                </Typography>
              </Box>
            </Draggable>
          );
        })}


      </Box>

    </Box>
  );
};

export default StakeholderWhiteboard;